// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__wx0Nt","input":"Switch_input__2ipf1","track":"Switch_track__A9yPp","thumb":"Switch_thumb__Bzkjw","label":"Switch_label__nt80Y"};